<template lang="html">
	<div 
		class="form-group" 
		v-if="form">
		<label :for="randomId">{{ label }}</label>
		<select 
			class="form-control input-sm" 
			:value="value && value.id ? value.id : value" 
			@input="onInput" 
			:placeholder="label" 
			v-show="computedOptions.length" 
			@keyup.enter="enter" 
			:disabled="disabled">
			<option 
				v-if="!(value && value.id && value.id>0) || nullable" 
				value="">--{{ label }}--</option>
			<option 
				v-for="option in computedOptions" 
				:selected="value && value.id && value.id==option.id" 
				:value="option.id">{{ option[name] }}</option>
		</select>
		<p v-show="!computedOptions.length">{{ placeholder }}</p>
	</div>
	<div 
		class="input-group" 
		v-else-if="unit">
		<select 
			class="form-control input-sm" 
			:value="value && value.id ? value.id : value" 
			@input="onInput" 
			:placeholder="label" 
			v-show="computedOptions.length" 
			@keyup.enter="enter" 
			:disabled="disabled">
			<option 
				v-if="!(value && value.id && value.id>0) || nullable" 
				value="">--{{ label }}--</option>
			<option 
				v-for="option in computedOptions" 
				:selected="value && value.id && value.id==option.id" 
				:value="option.id">{{ option[name] }}</option>
		</select>
		<p v-show="!computedOptions.length">{{ placeholder }}</p>
		<span class="input-group-addon addon-sm">{{ unit }}</span>
	</div>
	<span v-else>
		<select 
			class="form-control input-sm" 
			:value="value && value.id ? value.id : value" 
			@input="onInput" 
			:placeholder="label" 
			v-show="computedOptions.length" 
			@keyup.enter="enter" 
			:disabled="disabled">
			<option 
				v-if="!(value && value.id && value.id>0) || nullable" 
				value="">--{{ label }}--</option>
			<option 
				v-for="option in computedOptions" 
				:selected="value && value.id && value.id==option.id" 
				:value="option.id">{{ option[name] }}</option>
		</select>
		<p v-show="!computedOptions.length">{{ placeholder }}</p>
	</span>
</template>
<script>
export default {
	data() {
		return {
			randomId: 'input-' + Math.random()
		}
	},
	props: {
		unit: String,
		label: String,
		value: {
			type: Object,
			default() {
				return null
			}
		},
		options: Array,
		form: {
			default: false
		},
		placeholder: {
			type: String,
			default: 'Optionen werden geladen'
		},
		nullable: Boolean,
		disabled: Boolean,
		name: {
			type: String,
			default: 'name'
		}
	},
	computed: {
		computedOptions() {
			const isInOptions = this.options.some(option => {
				return this.value && this.value.id == option.id
			})
			if (!isInOptions && this.options.length == 1 && !this.nullable) {
				this.$emit('input', this.options[0])
				return this.options
			}
			if (
				isInOptions ||
				this.value === null ||
				(this.value && this.value.id < 0)
			)
				return this.options

			const options = this.options.slice()
			options.push(this.value)
			return options.slice()
		}
	},
	methods: {
		onInput(event) {
			const result =
				this.options.find(option => {
					return option.id == event.target.value
				}) || null
			this.$emit('input', result)
		},
		enter() {
			this.$emit('enter')
		}
	}
}
</script>

<style lang="css">
</style>
